import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_gzt8ah926u: FaireBrandEntity = {
  token: "b_gzt8ah926u",
  type: "brand",
  name: "Lèmme",
  avatarUrl:
    "https://cdn.faire.com/fastly/2119d6dd080f2057de632abf95e85bbf8870ef17e4237bcf242f241ca8e8b43c.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/a04747b1469b4b7835f01c6c0a78bb45a88f4a170e11807b02ca0ba651d05b40.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/2119d6dd080f2057de632abf95e85bbf8870ef17e4237bcf242f241ca8e8b43c.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/a04747b1469b4b7835f01c6c0a78bb45a88f4a170e11807b02ca0ba651d05b40.jpeg",
  location: "ITA",
  minimumOrderDollars: 0,
  rating: 4.9,
  reviewCount: 57,
  isTopShop: true,
  isInsider: false,
  description:
    "La dolce vita isn’t about grand gestures or fleeting trends. It’s about recognizing the right moment, appreciating simplicity and the effortless beauty of a unique experience that, with awareness, becomes something to be truly cherished. It’s the warmth of the Tuscan landscape, the gentle rhythm of life here, and the mastery of artisans who pour their heart into each creation. \n\nAt Lèmme, we honour this spirit, by creating garments that are made to last, that can be passed down from one generation to the next, each piece becomes part of your story, a true heirloom when treated with the care and respect it deserves.\n\nBecause the best things in life come slowly.\n\nTrue luxury begins with the finest materials. At Lèmme, we believe that to create knitwear that truly feels special, it all starts with the best fibers. \n\nThe finer the yarn, the softer it feels against the skin, and the longer the fiber, the more durable it becomes, resisting wear and tear over time. \n\nThis is why we use only the finest, longest yarns, ensuring that each of our pieces remains a symbol of comfort and elegance for years to come.\n\nOur natural yarns are sourced from legendary suppliers like Loro Piana, Todd & Duncan, and Zegna & Baruffa. \n\nThese renowned names, with a history spanning generations, have quietly crafted some of the world’s most exquisite materials, supplying luxury houses and tailors. Their legacy of excellence matches perfectly with our commitment to quality.",
  meta: {
    source: "api",
    importedAt: "2026-05-06T17:57:49.364Z",
    importedBy: "entity-db-cli",
  },
};
